/* Simulateur de credit-bail : meme calcul que le simulateur materiel MACSF (bareme valable au 31/10/2026).
   Saisie et affichage TTC. Calcul sur le montant HT (TTC / 1,2) ; loyers et option d'achat x 1,2 ;
   assurance DII (0,0591 % du montant HT par mois, non soumise a TVA) ajoutee a chaque loyer. */
if (!customElements.get('financement-simulateur')) {
  const FS_TVA = 1.2;
  const FS_DII = 0.000591;

  class FinancementSimulateur extends HTMLElement {
    connectedCallback() {
      this.min = Math.ceil(Number(this.dataset.min) * FS_TVA);
      this.max = Number(this.dataset.max);
      this.tiers = this.dataset.tiers.split(';').map((t) => {
        const [max, rate] = t.split(':');
        return { max: Number(max), rate: Number(String(rate).replace(',', '.')) };
      }).filter((t) => t.max > 0 && t.rate > 0);
      this.range = this.querySelector('[data-fs-range]');
      this.amount = this.querySelector('[data-fs-amount]');
      this.money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
      this.percent = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });
      const whole = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      this.out('hint', `Entre ${whole.format(this.min)} et ${whole.format(this.max)} TTC`);

      this.range.addEventListener('input', () => {
        this.amount.value = this.range.value;
        this.update();
      });
      this.amount.addEventListener('input', () => {
        this.range.value = this.amount.value;
        this.update();
      });
      this.amount.addEventListener('change', () => {
        this.amount.value = this.clamp(Number(this.amount.value));
        this.range.value = this.amount.value;
        this.update();
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-fs-first], [data-fs-duration]')) this.update();
      });
      if (this.dataset.productId) {
        document.addEventListener('on:variant:change', (e) => {
          const { variant, product } = e.detail;
          if (!variant || String(product.id) !== this.dataset.productId) return;
          // Variante sous le minimum du bareme : simulateur et lien sous le prix masques
          const off = variant.price / 100 < this.min;
          const section = this.closest('#financement');
          const cta = document.querySelector('.pp-fs-cta');
          if (section) section.hidden = off;
          if (cta) cta.hidden = off;
          if (off) return;
          this.amount.value = this.clamp(variant.price / 100);
          this.range.value = this.amount.value;
          this.update();
        });
      }
      this.update();
    }

    clamp(v) {
      return Math.min(this.max, Math.max(this.min, Math.round(v) || this.min));
    }

    rateFor(amount) {
      const tier = this.tiers.find((t) => amount <= t.max) || this.tiers[this.tiers.length - 1];
      return tier.rate;
    }

    // Loyer constant sur t mois avec valeur residuelle vc, loyers payes d'avance (MACSF mhaCalLOA)
    loa(t, m, rate, vc) {
      const ta = rate / 1200;
      return -((-m + vc * Math.pow(1 + ta, -t)) * ta / (1 - Math.pow(1 + ta, -t)) / (1 + ta));
    }

    // Bareme MACSF : 72 et 84 mois a partir de 7 500 EUR HT ; 84 mois avec 1er loyer majore a partir de 15 000 EUR HT
    durationAllowed(months, amount, first) {
      if (months >= 72 && amount < 7500) return false;
      if (months === 84 && first !== 'min' && amount < 15000) return false;
      return true;
    }

    update() {
      const amount = this.clamp(Number(this.amount.value)) / FS_TVA;
      const first = this.querySelector('[data-fs-first]:checked').value;
      const inputs = [...this.querySelectorAll('[data-fs-duration]')];
      inputs.forEach((i) => { i.disabled = !this.durationAllowed(Number(i.value), amount, first); });
      if (this.querySelector('[data-fs-duration]:checked').disabled) inputs.filter((i) => !i.disabled).pop().checked = true;
      const months = Number(this.querySelector('[data-fs-duration]:checked').value);
      const rate = this.rateFor(amount);
      // Valeur residuelle : 1 % jusqu'a 60 mois ; au-dela, calcul sans residuel et option d'achat de 1 EUR (xlsx MACSF)
      const option = months < 72 ? amount / 100 : 1;
      const residual = months < 72 ? option : 0;
      const firstRent = first === 'min'
        ? this.loa(months, amount, rate, residual)
        : amount * Number(first) / 100 - amount / 10000 * 4;
      const financed = (amount - firstRent) * (1 + rate / 1200);
      const rent = this.loa(months - 1, financed, rate, residual);
      const dii = amount * FS_DII;

      this.out('rent', this.money.format(rent * FS_TVA + dii));
      this.out('first', this.money.format(firstRent * FS_TVA + dii));
      this.out('count', `${months - 1} × ${this.money.format(rent * FS_TVA + dii)}`);
      this.out('option', this.money.format(option * FS_TVA));
      this.out('rate', `${this.percent.format(rate)} %`);
    }

    out(key, value) {
      this.querySelector(`[data-fs-out="${key}"]`).textContent = value;
    }
  }

  customElements.define('financement-simulateur', FinancementSimulateur);
}
